import React from "react";
import  './Resources/Actions.css';
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function Accounts(){
    const navigate = useNavigate();
    const user = localStorage.getItem("utype");
    const APP_NAME = process.env.REACT_APP_NAME;

    return(
        <>
       
       <div style = {{height:"100%", width:"100%"}}>
            <div className="reportheader">{APP_NAME} </div>
            
            <Navbar/>
            { user === "1" ?  <>   
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/expenses')}}>Expenses</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/deposits')}}>Deposits</div>
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/userdayclosing')}}>Day Closing</div></> :<></>}
        <div className="styles" style ={{marginTop:"30px"}} onClick={()=>{navigate('/loandetails')}}>Reports</div>
        </div>
        <button type="button" className="backbutton" onClick={()=>{navigate('/home')}}>Back</button>
        </>)
}